import { NAME } from '../constants';
import { IAuthState } from '../types';

export const getToken = (state: any) => state[NAME].token;
export const getRememberMe = (state: any) => state[NAME].rememberMe;
export const getMfaToken = (state: any) => state[NAME].mfaToken;
export const isLoggedIn = (state: any) => !!state[NAME].token?.length;
export const getState = (state: any): IAuthState => state[NAME];
